import React, { useState } from 'react';
import { RatingBar } from '@ubeya/shared-web/components';
import { EMPLOYEE_CLIENT_PREFERENCE_STATUS } from '@ubeya/shared-web/utils/employee';
import { trackEvent } from '@ubeya/shared-web/analytics/amplitude';
import { BlockEmployeeOnRatingModal, MarkPreferredOnRatingModal } from 'timeSheet/components/CellRenderers';

const RatingRenderer = ({
  rowData,
  rowData: { slotId, orderId, shiftId, rating, summarized, isExternal, employee, isThirdParty },
  columnData: { onChangeRating, mappedEmployeesClientStatus, enableBlockClients, onEmployeeStatusChange }
}) => {
  const [showBlockModal, setShowBlockModal] = useState(false);
  const [showMarkPreferredModal, setShowMarkPreferredModal] = useState(false);

  if (summarized) {
    return <></>;
  }

  const preferOrBlockModalHandler = (newRating) => {
    const employeeClientStatus = mappedEmployeesClientStatus?.[employee?.id]?.status;
    const enableRatingModals = isExternal && !isThirdParty;
    if (!enableRatingModals) return;

    if (newRating === 1 && employeeClientStatus !== EMPLOYEE_CLIENT_PREFERENCE_STATUS.BLOCKED && !!enableBlockClients) {
      setShowBlockModal(true);
    }
    if (newRating === 5 && employeeClientStatus !== EMPLOYEE_CLIENT_PREFERENCE_STATUS.PREFERRED) {
      setShowMarkPreferredModal(true);
    }
  };

  const handleChangeRating = (newRating) => {
    onChangeRating({ slotId, shiftId, orderId, slot: { rating: newRating } });
    const employeeId = employee?.id;
    if (employeeId) {
      trackEvent('Star rating changed', {
        employee_id: employeeId,
        star_rating: newRating,
        module: 'Order Tab'
      });
    }
    preferOrBlockModalHandler(newRating);
  };

  return (
    <>
      <RatingBar center={false} rating={rating} onChange={handleChangeRating} />
      {showBlockModal && (
        <BlockEmployeeOnRatingModal
          data={rowData}
          onClose={() => setShowBlockModal(false)}
          onEmployeeStatusChange={onEmployeeStatusChange}
          isClient={!rowData?.clientId && !rowData?.clientBranch?.accountId}
        />
      )}
      {showMarkPreferredModal && (
        <MarkPreferredOnRatingModal
          data={rowData}
          onClose={() => setShowMarkPreferredModal(false)}
          onEmployeeStatusChange={onEmployeeStatusChange}
          isClient={!rowData?.clientId && !rowData?.clientBranch?.accountId}
        />
      )}
    </>
  );
};

export default RatingRenderer;
